import { defineMessage } from 'services/localization';

export const messages = {
    requestAMBlockedValidationErrorManager: defineMessage('this_request_cannot_be__e_lock_date_in_xerolink'),
    requestBlockedValidationErrorManager: defineMessage('this_request_cannot_be__toeditfinancialsettings'),
    requestBlockedValidationErrorUser: defineMessage('this_request_can_not_be_een_notified_about_this'),
    validationErrorTextLockDateInEffect: defineMessage('document_date_cannot_be_rrently_set_at_lockdate'),
};
